import React from 'react'
import { Button, Col, Form, Row } from 'antd'
import questions from './Questions'
import QuestionWrapper from './QuestionWrapper'

type Props = {
    handleStepChange: (value: number) => void
    currentStep: number
    tipoUsina: string
    formType: string
}

const FormStep0 = (props: Props) => {
    const loadedQuestions = questions();

    return (
        <>
            <Row>
                <Col md={24} lg={18} xl={14} xxl={10}>
                    <QuestionWrapper
                        question={loadedQuestions.q1}
                        formType={props.formType}
                    />
                    <QuestionWrapper
                        question={loadedQuestions.q2}
                        formType={props.formType}
                    />
                    <QuestionWrapper
                        question={loadedQuestions.q3}
                        formType={props.formType}
                    />
                    <QuestionWrapper
                        question={loadedQuestions.q4}
                        formType={props.formType}
                    />
                    <QuestionWrapper
                        question={loadedQuestions.q5}
                        formType={props.formType}
                    />
                    <QuestionWrapper
                        question={loadedQuestions.q6}
                        formType={props.formType}
                    />
                    {props.tipoUsina === 'COBERTURA' && (
                        <QuestionWrapper
                            question={loadedQuestions.q7}
                            formType={props.formType}
                        />
                    )}
                    <Row>
                        <Col
                            xs={{ span: 24, offset: 0 }}
                            lg={{ span: 8, offset: 16 }}
                            xl={{ span: 6, offset: 18 }}
                        >
                            <Form.Item>
                                <Button
                                    style={{ width: '100%' }}
                                    type={'primary'}
                                    onClick={(e) =>
                                        props.handleStepChange(
                                            props.currentStep + 1
                                        )
                                    }
                                >
                                    Próximo
                                </Button>
                            </Form.Item>
                        </Col>
                    </Row>
                </Col>
            </Row>
        </>
    )
}

export default FormStep0
